var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"address-list"},_vm._l((_vm.list),function(item){return _c('li',{key:`address-${item.id}`,staticClass:"address-list__item"},[_vm._t("default",null,{"item":item})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }